import { useContext } from 'react';
import { AuthContext, type AuthState } from './auth-context';

export function useCurrentUser(): AuthState {
  return useContext(AuthContext);
}
